<template>
  <div class="w-full max-w-170">
    <SelectModule v-model="computedRole" class="text-14 rounded-4" width="w-250" :options="filteredRoles" :disabled="disabled">
      <template #option="{ item }">
        <span class="font-semibold text-15 leading-tiny">{{ item.name }}</span>
        <span class="font-normal text-12 leading-tiny italic">{{ item.description }}</span>
      </template>
    </SelectModule>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

import roles from '@/components/team/roles'
import SelectModule from '@/components/shared/form-controls/SelectModule'
import { useStore } from 'vuex'

export default defineComponent({
  components: { SelectModule },

  props: {
    role: String,
    disabled: Boolean
  },

  emits: ['setRole'],

  setup (props, { emit }) {
    const { state } = useStore()

    const member = computed(() => state.team.member)

    const filteredRoles = computed(() => {
      if (member.value.teamRole.name === 'super user') {
        return roles.filter((r) => r.name !== 'Admin')
      } else {
        return roles
      }
    })

    const computedRole = computed({
      get: () => {
        const r = roles.find(rl => rl.type === props.role)
        if (!r) {
          return {
            name: 'No role'
          }
        }
        return r
      },
      set: (value) => {
        emit('setRole', value.type)
      }
    })

    return { computedRole, filteredRoles }
  }
})
</script>

<style lang="scss" scoped>
.expanded {
  transform: rotateZ(180deg) translateY(2px);
}
</style>
